import React from 'react';
import classnames from 'classnames';
import Image from 'swag-client-common/components/ui/image';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import { RemoveIconButton } from '../../../../ui/remove-icon-button';
import { FileName } from '../file-name';
import classes from './logo-item.scss';
export const LogoItem = ({
  isSelected,
  logo,
  logo: {
    preview,
    originalFileName
  },
  withShadow,
  className,
  isLastLogo,
  onClick,
  onDelete
}) => {
  const handleSelect = () => {
    onClick(logo);
  };
  const handleDelete = event => {
    event.stopPropagation();
    onDelete(logo, isLastLogo);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.logoItem, className, {
      [classes.selectedLogoItem]: isSelected,
      [classes.withShadow]: withShadow
    }),
    onClick: handleSelect,
    tabIndex: 0,
    onKeyDown: e => handleOnEnterPressed(e, handleSelect)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.logoPanel
  }, /*#__PURE__*/React.createElement(RemoveIconButton, {
    className: classes.removeButton,
    onClick: handleDelete
  })), /*#__PURE__*/React.createElement(Image, {
    wrapperClassName: classes.logo,
    src: preview,
    alt: originalFileName
  }), /*#__PURE__*/React.createElement(FileName, {
    className: classes.fileName,
    name: logo.originalFileName
  }));
};